"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveFailure = exports.saveComplete = exports.saveSettings = exports.SaveSettings = exports.SaveSettingsActionTypes = exports.loadIP = exports.FetchIP = exports.FetchIPActionTypes = exports.stageSetting = exports.loadSettings = exports.FetchSettings = exports.FetchSettingsActionTypes = exports.SettingsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var SettingsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_SETTINGS: null,
  STAGE_SETTING: null,
  FETCH_IP: null,
  SAVE_SETTINGS: null,
  SAVE_COMPLETE: null,
  SAVE_FAILURE: null
}, 'analytics-and-tracking');
exports.SettingsActionTypes = SettingsActionTypes;
var FetchSettingsActionTypes = (0, _actions.createRequestTypes)(SettingsActionTypes.FETCH_SETTINGS);
exports.FetchSettingsActionTypes = FetchSettingsActionTypes;
var FetchSettings = (0, _actions.createRequestActions)(FetchSettingsActionTypes);
exports.FetchSettings = FetchSettings;
var loadSettings = (0, _fluxActions.createAction)(SettingsActionTypes.FETCH_SETTINGS);
exports.loadSettings = loadSettings;
var stageSetting = (0, _fluxActions.createAction)(SettingsActionTypes.STAGE_SETTING, function (key, value) {
  return {
    key: key,
    value: value
  };
});
exports.stageSetting = stageSetting;
var FetchIPActionTypes = (0, _actions.createRequestTypes)(SettingsActionTypes.FETCH_IP);
exports.FetchIPActionTypes = FetchIPActionTypes;
var FetchIP = (0, _actions.createRequestActions)(FetchIPActionTypes);
exports.FetchIP = FetchIP;
var loadIP = (0, _fluxActions.createAction)(SettingsActionTypes.FETCH_IP);
exports.loadIP = loadIP;
var SaveSettingsActionTypes = (0, _actions.createRequestTypes)(SettingsActionTypes.SAVE_SETTINGS);
exports.SaveSettingsActionTypes = SaveSettingsActionTypes;
var SaveSettings = (0, _actions.createRequestActions)(SaveSettingsActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.settings.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.settings.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SettingsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.SaveSettings = SaveSettings;
var saveSettings = (0, _fluxActions.createAction)(SettingsActionTypes.SAVE_SETTINGS, function (settings) {
  return settings;
});
exports.saveSettings = saveSettings;
var saveComplete = (0, _fluxActions.createAction)(SettingsActionTypes.SAVE_COMPLETE);
exports.saveComplete = saveComplete;
var saveFailure = (0, _fluxActions.createAction)(SettingsActionTypes.SAVE_FAILURE);
exports.saveFailure = saveFailure;